import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { CardLayout, MTable } from "../v3";
import { ContractTableColumns } from "../../pages/subcontractors/constants";
import { AnalyticsService, ProjectService } from "../../services";
import { derivePdfColumns, getPrintableRows } from "../../utils";
import { handlePdfDownload, Listing } from "../pdf";

export const ProjectSummary = ({ name = "Subcontractor", subcontractorId, reloadData }) => {
  const [projectSummary, setProjectSummary] = useState([]);
  const [projectsOfContracts, setProjectsOfContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    fetchData(subcontractorId);
  }, [reloadData, subcontractorId]);

  const fetchData = async (subcontractorId) => {
    try {
      setLoading(true);
      const { data } = await AnalyticsService.getSubcontractorProjectSummary(subcontractorId);
      setProjectSummary(data);

      const projectIds = Array.from(new Set(data.map((item) => item.projectId)));
      if (projectIds.length > 0) {
        const projectResponse = await ProjectService.getProjectList({
          ids: projectIds.join(","),
          limit: projectIds.length,
          includeDeleted: true,
        });
        setProjectsOfContracts(projectResponse?.data?.rows);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch contracts");
    }
  };

  const handleDownloadPdfClick = async () => {
    setIsPdfGenerating(true);
    try {
      const pdfColumnHeaders = derivePdfColumns(ContractTableColumns);
      const printableRows = getPrintableRows(rows);

      const pdfDocument = (
        <Listing
          title={`Contract Summary : ${name}`}
          columnHeaders={pdfColumnHeaders}
          tableRows={printableRows}
          company={user?.company}
        />
      );

      await handlePdfDownload({
        document: pdfDocument,
        pdfTitle: `Contract Summary : ${name}`,
      });
    } catch (error) {
      toast.error("PDF generation failed");
    } finally {
      setIsPdfGenerating(false);
    }
  };

  const rows = projectSummary
    ? projectSummary.map((contract, index) => {
        const project = projectsOfContracts.find((project) => project.id === contract.projectId);
        return {
          sl: index + 1,
          id: index,
          projectName: project?.name,
          totalAmount: contract?.totalContractValue,
          totalPayment: contract?.totalExpense,
          balance: Number(contract?.totalContractValue) - Number(contract?.totalExpense),
        };
      })
    : [];

  return (
    <CardLayout>
      <MTable
        // Export data
        showExportButton // TODO: implement permission
        isPdfGenerating={isPdfGenerating}
        onExportPdfClick={handleDownloadPdfClick}
        columnHeaders={ContractTableColumns}
        tableRows={rows}
        loading={loading}
        hideFooter
      />
    </CardLayout>
  );
};
